import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useLang } from "@/lib/lang";
import { Home, Calendar, Wallet, User, LogOut } from "lucide-react";

const NAV = [
  { to: "/driver", label: "today", icon: Home, end: true },
  { to: "/driver/schedule", label: "schedule", icon: Calendar },
  { to: "/driver/earnings", label: "earnings", icon: Wallet },
  { to: "/driver/profile", label: "profile", icon: User },
];

export default function DriverLayout() {
  const { user, logout } = useAuth();
  const { t, lang, setLang } = useLang();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-white flex justify-center">
      <div className="w-full max-w-md min-h-screen bg-white pb-24 relative border-x border-slate-200">
        {/* Header */}
        <div className="px-5 pt-6 pb-4 border-b border-slate-200 flex items-center justify-between sticky top-0 bg-white z-20">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 border border-[#f59e0b] flex items-center justify-center">
              <span className="font-display text-[#f59e0b]">D</span>
            </div>
            <div>
              <div className="font-display text-lg text-[#0a0f1e] leading-none">DiTours</div>
              <div className="text-[9px] label-caps text-slate-500">Driver</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex text-[10px] border border-slate-200">
              {["PT", "EN"].map((l) => (
                <button key={l} onClick={() => setLang(l)} data-testid={`lang-${l}`} className={`px-2 py-1 uppercase ${lang === l ? "bg-[#f59e0b] text-[#0a0f1e]" : "text-slate-500"}`}>{l}</button>
              ))}
            </div>
            <button onClick={async () => { await logout(); nav("/login"); }} className="text-slate-500 hover:text-[#f59e0b]" data-testid="driver-logout">
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>

        <Outlet />

        {/* Bottom nav */}
        <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white border-t border-slate-200 h-16 flex items-center justify-around z-30">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`drv-nav-${item.label}`}
              className={({ isActive }) => `flex flex-col items-center gap-1 flex-1 h-full justify-center ${isActive ? "text-[#f59e0b]" : "text-slate-500"}`}
            >
              <item.icon className="w-5 h-5" strokeWidth={1.5} />
              <span className="text-[10px] uppercase tracking-wide">{t(item.label)}</span>
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
}
